




















import BaseComponent from '@/components/base/BaseComponent';
import { Component, Prop } from 'vue-property-decorator';
import { MenuAction } from '@/models/MenuAction.model';

@Component({})
export default class FlatDropdownMenuComponent extends BaseComponent {

  // component that catches the events
  @Prop()
  public requestorCallback!: any;

  // include this data when event emitted
  @Prop()
  public outSourceData!: any;

  // list of menu actions
  @Prop(Array)
  public menuActions!: string[];

  // dropdown open menu classes
  @Prop(String)
  public menuClasses!: string;

  // font awesome icon name for the menu
  @Prop({ type: String, default: 'cog' })
  public faMenuIconName!: string;

  // font awesome icon type for the menu
  @Prop({ type: String, default: 'fal' })
  public faMenuIconType!: string;

  // material design icon name for the menu
  @Prop(String)
  public mdMenuIconName!: string;

  private dropdownMenuId: string = '';
  private openMenu: boolean = false;

  private created() {
    const uuidv1 = require('uuid/v1');
    this.dropdownMenuId = 'menu' + uuidv1();
  }

  private onMenuActionClicked(menuAction: MenuAction): void {
    if (this.requestorCallback) {
      this.requestorCallback.$emit(menuAction.event || '', menuAction, this.outSourceData);
    } else {
      this.$emit(menuAction.event || '', menuAction, this.outSourceData);
    }
    if (menuAction.routingInfo) {
      this.$router.push({ name: menuAction.routingInfo, params: { data: this.outSourceData } });
    }
    this.openMenu = false;
  }

  private itemClicked(menuAction: MenuAction): void {
    this.$emit('itemClicked', menuAction);
    this.openMenu = false;
  }

  private closeDropdown() {
    this.openMenu = false;
  }

}
